module.exports = __webpack_public_path__ + "static/drumster-caseimg-min-0f89018952d89e79b63bc0915c92ba23.png";